const r = {
  primary: {
    bg: "secondary",
    borderRadius: "lg",
    p: [5, null, 6]
  },
  scaleOnHover: {
    img: {
      transition: "transform 0.4s"
    },
    ":hover": {
      img: {
        transform: "scale(1.05, 1.05)",
        transition: "transform 0.4s"
      }
    }
  },
  scaleContentOnHover: {
    transition: "transform 0.4s",
    ":hover": {
      transform: "scale(1.05, 1.05)",
      transition: "transform 0.4s"
    }
  }
};
export {
  r as cards
};
